<script>
	// imports
	import model from "../../stores/modelStore";
	import { projectSettings } from "../../config";
	import { isValid } from "../../validation";
	import { registerPageComplete } from "../../tealium";

	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import YesNoGroup from "../../components/YesNoGroup.svelte";
	import Relatives from "../../components/Relatives.svelte";
	import SaveAndClose from "../../components/SaveAndClose.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";

	// props
	export let pageName = null;
	export let persistUrl = null;
	export let pageTitle = null;
	export let disabled = false;
	export let lastVisitedPage = null;

	let buttons = null;

	// component state updating
	if (!disabled) {
		$model.lastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}

	const handleSubmit = async (e) => {
		buttons.blockNext();

		let errors = isValid();

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(displayError);
				//displayError(response);
			} else {
				registerPageComplete(pageName, $model.contact.emailAddress, $model.contact.phoneNumber);
				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};
</script>

<section>
	<Form {disabled} id="form-family-medical-history" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName}</h4>
				<h1 class="text-center">Family Medical History</h1>
				<p>
					If you are unable to complete any part of this section of the form, we are here to assist you.
					Please contact us on <ClassActionPhoneNumber /> or via email to <ClassActionEmailAddress />.
				</p>
			</FormColumn>
		</FormRow>

		<hr class="primary" />

		<div class="confirmation-box-shadow">
			<p>
				<strong>
					Please limit your response to these questions to blood relatives, being your parents, siblings,
					children, grandparents, aunts, uncles and first cousins.
				</strong>
			</p>

			<FormRow>
				<FormColumn>
					<YesNoGroup
						required
						{disabled}
						name="relativeDiagnosedWithCancer"
						label="Have any of your relatives been diagnosed with cancer?"
						bind:value={$model.familyMedicalHistory.relativeDiagnosedWithCancer}
					/>
				</FormColumn>
			</FormRow>

			{#if $model.familyMedicalHistory.relativeDiagnosedWithCancer === "Yes"}
				<FormRow>
					<FormColumn>
						<Relatives
							{disabled}
							bind:relatives={$model.familyMedicalHistory.cancerRelatives}
							diagnosisType="CANCER"
						/>
					</FormColumn>
				</FormRow>
			{/if}

			<FormRow>
				<FormColumn>
					<YesNoGroup
						required
						{disabled}
						name="relativeDiagnosedWithGeneticMutation"
						label="Have any of your relatives been diagnosed with any genetic mutations, including not limited to BRCA1 or BRCA2 mutations?"
						bind:value={$model.familyMedicalHistory.relativeDiagnosedWithGeneticMutation}
					/>
				</FormColumn>
			</FormRow>

			{#if $model.familyMedicalHistory.relativeDiagnosedWithGeneticMutation === "Yes"}
				<FormRow>
					<FormColumn>
						<Relatives
							{disabled}
							bind:relatives={$model.familyMedicalHistory.geneticRelatives}
							diagnosisType="GENETIC"
						/>
					</FormColumn>
				</FormRow>
			{/if}
		</div>

		<FormRow class="confirmation-hide">
			<FormColumn class="last">
				<SaveAndClose>Save and Close</SaveAndClose>
			</FormColumn>
		</FormRow>

		<FormRow class="confirmation-hide">
			<FormColumn class="last">
				<NavigationButtons bind:buttons nextPageLabel={$model.confirmationPage ? "Confirmation" : "Next"} />
			</FormColumn>
		</FormRow>
	</Form>
</section>

<style>
</style>
